import e from "./useMutationObserver.js";
import { getDocumentBrand as t, setDocumentBrand as n } from "../utils/init/initCSS.js";
import { useCallback as r, useState as i } from "react";
//#region src/hooks/useBrand.ts
var a = () => {
	let [a, o] = i(t), s = r((e) => {
		o(n(e));
	}, []), c = r((e) => {
		e.some((e) => e.type === "attributes" && e.attributeName === "data-brand") && o(t());
	}, []);
	return e(document.documentElement, c, {
		attributes: !0,
		childList: !1,
		subtree: !1
	}), {
		brand: a,
		setBrand: s
	};
};
//#endregion
export { a as default };

//# sourceMappingURL=useBrand.js.map